"use client";

import { cva } from "class-variance-authority";
import { User } from "lucide-react";
import { Avatar, AvatarImage } from "@shared-components/shadcn/avatar";
import { api } from "@shared-server/api";
import { cn } from "@shared-utils/ui";
import { Tooltip, TooltipContent, TooltipTrigger } from "./shadcn/tooltip";
import { ADUserCard } from "@shared-components/ad-user-card";
interface ADUserAvatarProps {
  // For most users the userPrincipalName is the email eg. jokje@leo-pharma.com
  imagePath?: string | null;
  name?: string | null;
  userPrincipalName?: string | null;
  size: "nano" | "micro" | "small" | "large" | "xlarge";
  className?: string;
}
const variants = cva("w-7 h-7", {
  variants: {
    size: {
      nano: "w-3 h-3",
      micro: "w-5 h-5",
      small: "w-7 h-7",
      large: "w-10 h-10",
      xlarge: "w-12 h-12"
    }
  }
});
export const ADUserAvatar = (props: ADUserAvatarProps) => {
  const imagePath = props.imagePath ?? (props.userPrincipalName ? api.msGraph.profilePhoto.useQuery({
    userPrincipalName: props.userPrincipalName
  }).data : null);
  const avatar = <Avatar className={cn("flex items-center justify-center border bg-brand-ter-bluegray-200 border-brand-ter-bluegray-300", props.className, variants({
    size: props.size
  }))}>
      {imagePath ? <AvatarImage className="bg-primary" src={imagePath} alt="@shadcn" /> : <User size={props.size === "small" ? 12 : 10} />}
    </Avatar>;
  return <Tooltip delayDuration={0}>
      <TooltipTrigger asChild disabled={!props.userPrincipalName}>
        {props.name ? <div className="flex flex-row items-center gap-1">
            {avatar}
            <span>{props.name}</span>
          </div> : avatar}
      </TooltipTrigger>
      {props.userPrincipalName && <TooltipContent alignOffset={30} sideOffset={0} side="bottom" align="start" className="p-0 bg-transparent">
          <ADUserCard imagePath={imagePath} userPrincipalName={props.userPrincipalName} />
        </TooltipContent>}
    </Tooltip>;
};